import React from 'react';

function isDev(): boolean {
  // Vite sets import.meta.env.MODE
  return (
    (import.meta as unknown as { env?: Record<string, string | undefined> }).env?.MODE !==
    'production'
  );
}

export default function DevFlagsBanner() {
  if (!isDev()) return null;

  const [hidden, setHidden] = React.useState<boolean>(() => {
    try {
      return localStorage.getItem('portal.devFlags.hide') === '1';
    } catch {
      return false;
    }
  });

  if (hidden) return null;

  const env = (import.meta as unknown as { env?: Record<string, string | undefined> }).env ?? {};
  const tcfEnableProxy = env.VITE_TCF_ENABLE === '1';
  const tcfApiPresent =
    typeof (window as unknown as { __tcfapi?: unknown }).__tcfapi === 'function';
  const tcfStatus = tcfApiPresent || tcfEnableProxy ? 'on' : 'off';
  // Prefer SDK flag if exposed; fall back to Vite variant
  // Note: Vite exposes only VITE_* at build time; also check an optional window.__env shim
  type Envish = Record<string, string | undefined>;
  const sdkGppV =
    (env as Envish)['GPP_USNAT_VERSION'] ??
    (globalThis as unknown as { __env?: Envish }).__env?.['GPP_USNAT_VERSION'] ??
    undefined;
  const viteGppV = env.VITE_GPP_USNAT_VERSION;
  const gppV = (sdkGppV ?? viteGppV ?? 'unset') as string;
  const gvl = env.VITE_TCF_GVL_URL ?? 'unset';

  return (
    <div
      data-testid="dev-flags-banner"
      style={{
        position: 'fixed',
        bottom: 8,
        left: 8,
        zIndex: 9999,
        padding: '6px 10px',
        borderRadius: 8,
        background: 'rgba(17,24,39,0.9)', // gray-900
        color: 'white',
        fontSize: 12,
        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
        maxWidth: 520,
      }}
    >
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <strong style={{ fontWeight: 600 }}>Flags</strong>
        <span title="TCF_ENABLE (proxy via Vite flag or __tcfapi presence)">
          TCF_ENABLE={tcfStatus}
        </span>
        <span title={`GPP_USNAT_VERSION (SDK=${sdkGppV ?? 'n/a'}, VITE=${viteGppV ?? 'n/a'})`}>
          GPP_USNAT_VERSION={gppV}
        </span>
        <span title={gvl || 'unset'}>VITE_TCF_GVL_URL={gvl ? 'set' : 'unset'}</span>
        <button
          aria-label="Hide dev flags"
          onClick={() => {
            try {
              localStorage.setItem('portal.devFlags.hide', '1');
            } catch {
              // ignore storage unavailability
            }
            setHidden(true);
          }}
          style={{
            marginLeft: 8,
            background: 'transparent',
            color: '#eee',
            border: '1px solid #555',
            borderRadius: 6,
            padding: '0 6px',
            lineHeight: '18px',
            cursor: 'pointer',
          }}
        >
          ×
        </button>
      </div>
    </div>
  );
}
